import { useState, useEffect } from "react";
import { LoremIpsum } from "lorem-ipsum";
import { DataStore } from "@aws-amplify/datastore";
import { uniqueNamesGenerator, names } from "unique-names-generator";
import { AmplifyAuthenticator, AmplifySignOut } from "@aws-amplify/ui-react";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";

import { Post } from "./models";
import "./App.css";

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 8,
    min: 4,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

const config = {
  dictionaries: [names],
};

const Toolbar = () => {
  const handleClick = async () => {
    const title = lorem.generateWords(2);
    const content = lorem.generateParagraphs(1);
    const author = uniqueNamesGenerator(config);

    await DataStore.save(
      new Post({
        title: title,
        content: content,
        author: author,
      })
    );
  };

  return (
    <div className="Toolbar">
      <button className="Button Generate" onClick={handleClick}>
        Generate Post
      </button>
    </div>
  );
};

const App = () => {
  const [allPosts, setAllPosts] = useState(null);
  const [authState, setAuthState] = useState();
  const [user, setUser] = useState();

  useEffect(() => {
    onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      setUser(authData);
    });

    async function getPosts() {
      const posts = await DataStore.query(Post);
      setAllPosts(posts);
    }

    getPosts();
  }, [allPosts, authState]);

  const handleUpdate = async (id) => {
    const content = lorem.generateParagraphs(1);
    const original = await DataStore.query(Post, id);
    await DataStore.save(
      Post.copyOf(original, (item) => {
        item.content = content;
      })
    );
  };

  const handleDelete = async (id) => {
    const modelToDelete = await DataStore.query(Post, id);
    DataStore.delete(modelToDelete);
  };

  return authState === AuthState.SignedIn && user ? (

      <div className="App">
        <AmplifySignOut />
        <header className="App-header">
          <p>My Blog</p>
        </header>
        <div className="App-container">
          <Toolbar />
          <div className="Content">
            <ul className="List">
              {allPosts &&
                allPosts.map((post) => {
                  return (
                    <li className="List-item">
                      <h1>{post.title}</h1>
                      <p>Author: {post.author}</p>
                      <p>{post.content}</p>
                      <div className="Action">
                        <button
                          className="Button Update"
                          onClick={() => handleUpdate(post.id)}
                        >
                          Random Update
                        </button>
                        <button
                          className="Button Delete"
                          onClick={() => handleDelete(post.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
  ) : (
    <AmplifyAuthenticator />
  );
};

export default App;
